/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import color from '../../../../constants/color';
import icons from '../../../../constants/icons';
// import icons from '../../../constants/icons';
import {
  ContainerInfoImageBody,
  RowCheck,
  Img,
  Space,
  Title,
  InfoImage,
  Ping,
  Button,
} from './styles';

interface Props {
  title: string;
  subTitle: string;
  imageTop: string;
  phase: number;
  onClick?: Function;
}

const Instructions: React.FC<Props> = ({
  phase, imageTop, title, subTitle, onClick,
}) => (
  <ContainerInfoImageBody>
    <Img height={80} width={80} src={imageTop} />
    <Space />
    <Title>{title}</Title>
    <Space />
    <InfoImage>
      {subTitle}
    </InfoImage>
    <Space />
    <Space />
    {phase === 1 && (
    <RowCheck>
      <Ping style={{ backgroundColor: color.Secondary }} />
      <Ping style={{ backgroundColor: color.Ping }} />
      <Ping style={{ backgroundColor: color.Ping }} />
      <Ping style={{ backgroundColor: color.Ping }} />
    </RowCheck>
    )}
    {phase === 2 && (
    <RowCheck>
      <Ping style={{ backgroundColor: color.Secondary }}>
        <Img height={10} width={14} style={{ marginBottom: 2 }} src={icons.checkIconPing} />
      </Ping>
      <Ping style={{ backgroundColor: color.Secondary }} />
      <Ping style={{ backgroundColor: color.Ping }} />
      <Ping style={{ backgroundColor: color.Ping }} />
    </RowCheck>
    )}
    {phase === 3 && (
    <RowCheck>
      <Ping style={{ backgroundColor: color.Secondary }}>
        <Img height={10} width={14} style={{ marginBottom: 2 }} src={icons.checkIconPing} />
      </Ping>
      <Ping style={{ backgroundColor: color.Secondary }}>
        <Img height={10} width={14} style={{ marginBottom: 2 }} src={icons.checkIconPing} />
      </Ping>
      <Ping style={{ backgroundColor: color.Secondary }} />
      <Ping style={{ backgroundColor: color.Ping }} />
    </RowCheck>
    )}
    {phase === 4 && (
    <RowCheck>
      <Ping style={{ backgroundColor: color.Secondary }}>
        <Img height={10} width={14} style={{ marginBottom: 2 }} src={icons.checkIconPing} />
      </Ping>
      <Ping style={{ backgroundColor: color.Secondary }}>
        <Img height={10} width={14} style={{ marginBottom: 2 }} src={icons.checkIconPing} />
      </Ping>
      <Ping style={{ backgroundColor: color.Secondary }}>
        <Img height={10} width={14} style={{ marginBottom: 2 }} src={icons.checkIconPing} />
      </Ping>
      <Ping style={{ backgroundColor: color.Secondary }} />
    </RowCheck>
    )}
    {phase === 5 && (
    <RowCheck>
      <Button
        onClick={() => onClick && onClick()}
        variant="contained"
        color="primary"
      >
        CADASTRAR OUTRO
      </Button>
    </RowCheck>
    )}
  </ContainerInfoImageBody>
);
export default Instructions;
